import React from 'react';
import { Box } from '@hover/blueprint';
import Heading from './Heading';
import Hero from './Hero';
import ShowCasePartners from '../common/ShowcasePartners';
import { PARTNERS_INTEGRATIONS } from '../../../constants/partners';

export const Integrations: typeof Box = props => (
  <Box d="block" w="100%" py={{ base: '80px', desktop: '100px' }} {...props}>
    <Heading />
    <Hero />
    <div id="integrations" />
    <ShowCasePartners partners={PARTNERS_INTEGRATIONS} />
  </Box>
);
